export enum CDP_PAGE_TYPES {
  MULTIPLE_CARDS = 'multiple-cards',
  CUSTOM_DENOMINATIONS = 'custom-denominations',
  PRODUCT_VARIANT = 'product_variant',
}
